enum AllocationTerritoryRoutes {
  List = '/allocation/territories',
  Add = '/allocation/territories/add',
  Edit = '/allocation/territories/edit/:id',
}

export default AllocationTerritoryRoutes
